import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import Icon from '@material-ui/core/Icon';
import React, {useEffect, useState} from 'react';
import {withStyles} from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import FormField from '../Form/FormField';
import FormCheck from '../Form/FormCheck';
import i18n from '../../i18n';
import FormColor from '../Form/FormColor';
import FormSelect from "../Form/FormSelect";

const AttachmentTypeEdit = (props) => {



    const [values, setValues] = useState(props.values);
    const [edit, setEdit] = useState(props.edit || false);
    const [prev, setPrev] = useState(props.values.auto_select_by);
    const [options,setOptions] = useState([]);

    const setOptionsList = (type) => {
        let selection;

        if(type && !props.typesList.includes(type)) {
            selection = [type,...props.typesList]
        } else {
            selection = props.typesList;
        }
        setOptions( selection.map(type => {
            return {
                label: i18n.get('file.type_form.types.' + type),
                value: type,
            }
        }) );
    }

    useEffect(() => setOptionsList(props.values.auto_select_by),[props]);

    return (
        <TableRow>
            <TableCell>
                {edit ? (
                    <FormField
                        type={'text'}
                        name={'name'}
                        label={i18n.get('file.type_form.name')}
                        value={values.name}
                        onChange={(e) => {
                            setValues({...values, name: e.target.value});
                        }}
                    />
                ) : values.name}
            </TableCell>
            {/*
            <TableCell>
                {edit ? (
                    <React.Fragment>
                        {values.color}
                        <FormColor
                            color={values.color || '#ffffff'}
                            onChange={(color) => {
                                setValues({...values, color: color});
                            }}
                        />
                    </React.Fragment>
                ) : (
                    <Icon style={{color: values.color}}>color_lens</Icon>
                )}
            </TableCell>
            */}
            {/*
            <TableCell>
                {edit ? (
                    <FormField
                        type={'number'}
                        name={'priority'}
                        max={1000}
                        min={-1000}
                        label={i18n.get('file.type_form.priority')}
                        value={values.priority}
                        onChange={(e) => {
                            let priority = parseInt(e.target.value);
                            if (priority === null) {
                                priority = 0;
                            }
                            setValues({...values, priority});
                        }}
                    />
                ) : values.priority}
            </TableCell>
            */}
            <TableCell align={'center'}>
                {edit ? (
                    <FormSelect
                        type={'text'}
                        name={'auto_select_by'}
                        label={i18n.get('file.type_form.auto_select_by')}
                        onChange={(e) => {
                            if(e && e.value){
                                setValues({...values, auto_select_by: e.value });
                                setPrev(e.value);
                            } else {
                                props.changeTypesList(prev,'restore');
                                setValues({...values, auto_select_by: null });
                            }
                        }}
                        options={options}
                        placeholder={i18n.get('file.type_form.select_type')}
                        value={values.auto_select_by || ''}
                        isClearable={true}
                    />
                ) : values.auto_select_by && i18n.get('file.type_form.types.' + values.auto_select_by)}
            </TableCell>
            <TableCell align={'center'}>
                {edit ? (
                    <React.Fragment>
                        <IconButton
                            onClick={() => {
                                setEdit(false);
                                if (props.onChange) {
                                    props.onChange(values);
                                }
                            }}
                        >
                            <Icon>save</Icon>
                        </IconButton>
                        <IconButton
                            onClick={() => {
                                setEdit(false);
                                setValues(props.values);
                            }}
                        >
                            <Icon>cancel</Icon>
                        </IconButton>
                    </React.Fragment>
                ) : (
                    <IconButton
                        onClick={() => {
                            setEdit(true);
                        }}
                    >
                        <Icon>edit</Icon>
                    </IconButton>
                )}
            </TableCell>
        </TableRow>
    );
};

const styles = {};

export default withStyles(styles)(AttachmentTypeEdit);
